import { createFromIconfontCN } from '@ant-design/icons';

export const MyIcon = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1471413_0pakbmcy70nr.js',
});

